import * as React from 'react';
import { Outlet } from 'react-router-dom';

const Home = React.lazy(() => import('./views/home/pages/HomePage'));
const RolesListPage = React.lazy(
  () => import('./views/accessControl/roles/pages/RolesListPage'),
);
const RoleFormPage = React.lazy(
  () => import('./views/accessControl/roles/pages/RoleFormPage'),
);
const RolePermissionsPage = React.lazy(
  () => import('./views/accessControl/roles/pages/RolePermissionsPage'),
);
const EstablishmentHomePage = React.lazy(
  () => import('./views/modules/pages/EstablishmentHomePage'),
);
const MedicalCompanyHomePage = React.lazy(
  () => import('./views/modules/pages/MedicalCompanyHomePage'),
);
const ProfileSettingsPage = React.lazy(
  () => import('./views/profile/pages/ProfileSettingsPage'),
);
const ProfessionalListPage = React.lazy(
  () =>
    import('./views/technicalStaff/professional/pages/ProfessionalListPage'),
);
const ProfessionalProfilePage = React.lazy(
  () =>
    import('./views/technicalStaff/professional/pages/ProfessionalProfilePage'),
);
const ProfessionalEditPage = React.lazy(
  () =>
    import('./views/technicalStaff/professional/pages/ProfessionalEditPage'),
);
const EstablishmentListPage = React.lazy(
  () =>
    import('./views/accessControl/establishment/pages/EstablishmentListPage'),
);
const EstablishmentFormPage = React.lazy(
  () =>
    import('./views/accessControl/establishment/pages/EstablishmentFormPage'),
);
const EstablishmentLinkProfessionalPage = React.lazy(
  () =>
    import('./views/accessControl/establishment/pages/EstablishmentProfessionalLinkedListPage'),
);

const OccupationListPage = React.lazy(
  () => import('./views/technicalStaff/occupations/pages/OccupationListPage'),
);
const RQEListPage = React.lazy(
  () => import('./views/technicalStaff/rqe/pages/RqeListPage'),
);
const DocumentValidationPage = React.lazy(
  () =>
    import('./views/technicalStaff/documentValidation/pages/DocumentValidationPage'),
);
const CategoriesListPage = React.lazy(
  () => import('./views/technicalStaff/categories/pages/CategoriesListPage'),
);
const CategoriesFormPage = React.lazy(
  () => import('./views/technicalStaff/categories/pages/CategoriesFormPage'),
);
const CouncilsPage = React.lazy(
  () => import('./views/technicalStaff/councils/pages/CouncilsPage'),
);
const CouncilConfigurationPage = React.lazy(
  () =>
    import('./views/technicalStaff/councils/pages/CouncilConfigurationPage'),
);
const CouncilTestPage = React.lazy(
  () => import('./views/technicalStaff/councils/pages/CouncilTestPage'),
);
const ScaleMain = React.lazy(
  () => import('./views/scaleManagement/scales/pages/ScalePage'),
);
const CalendarMainPage = React.lazy(
  () => import('./views/scaleManagement/calendar/pages/CalendarMainPage'),
);
const RecordsMainPage = React.lazy(
  () => import('./views/scaleManagement/records/pages/RecordsMainPage'),
);
const FaceSignIntercurrencesPage = React.lazy(
  () =>
    import('./views/scaleManagement/facesignIntercurrences/pages/FaceSignIntercurrencesPage'),
);
const ManageEstablishment = React.lazy(
  () =>
    import('./views/myEstablishment/manageEstablishment/pages/ManageEstablishmentPage'),
);
const EstablishmentCategoriesPage = React.lazy(
  () => import('./views/myEstablishment/establishmentCategories/pages/EstablishmentCategoriesPage'),
);
const EstablishmentCategoryRegisterPage = React.lazy(
  () => import('./views/myEstablishment/establishmentCategories/pages/EstablishmentCategoryRegisterPage'),
);
const EstablishmentCategoryEditPage = React.lazy(
  () => import('./views/myEstablishment/establishmentCategories/pages/EstablishmentCategoryEditPage'),
);
const WorkDayEstablishment = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentWorkday/pages/WorkDayEstablishmentPage'),
);
const SectorEstablishment = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentSector/pages/SectorListPage'),
);
const SectorEstablishmentRegister = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentSector/pages/SectorFormPage'),
);
const RoomEstablishment = React.lazy(
  () => import('./views/myEstablishment/establishmentRoom/pages/RoomListPage'),
);
const RoomEstablishmentRegister = React.lazy(
  () => import('./views/myEstablishment/establishmentRoom/pages/RoomFormPage'),
);
const RoomAuthorizedProfessionalsPage = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentRoom/pages/RoomAuthorizedProfessionalsPage'),
);
const UsersEstablishment = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentUsers/pages/UsersEstablishmentListPage'),
);
const UsersEstablishmentRegister = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentUsers/pages/UsersEstablishmentFormPage'),
);
const EstablishmentProfessional = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentProfessional/pages/EstablishmentProfessionalListPage'),
);
const EstablishmentProfessionalLinked = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentProfessional/pages/EstablishmentProfessionalLinkedPage'),
);
const EstablishmentProfessionalProfilePage = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentProfessional/pages/EstablishmentProfessionalProfilePage'),
);
const EstablishmentStatutoryProfessionalPage = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentProfessional/pages/EstablishmentStatutoryProfessionalPage'),
);
const EstablishmentSpecialityPage = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentSpeciality/pages/SpecialityEstablishmentPage'),
);
const EstablishmentSpecialityFormPage = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentSpeciality/pages/SpecialityEstablishmentFormPage'),
);
const ManageUserListPage = React.lazy(
  () => import('./views/accessControl/manageUser/pages/ManageUserListPage'),
);
const ManageUserFormPage = React.lazy(
  () => import('./views/accessControl/manageUser/pages/ManageUserFormPage'),
);
const AuditLogListPage = React.lazy(
  () => import('./views/accessControl/auditLog/pages/AuditLogListPage'),
);
const InviteCodeListPage = React.lazy(
  () => import('./views/accessControl/inviteCodes/pages/InviteCodeListPage'),
);
const FaceSignAnalysisDeskPage = React.lazy(
  () =>
    import('./views/accessControl/facesignAnalysisDesk/pages/FaceSignAnalysisDeskPage'),
);
const FaceSignEventsPage = React.lazy(
  () => import('./views/accessControl/facesignEvents/pages/FaceSignEventsPage'),
);
const AdminPushNotificationsPage = React.lazy(
  () =>
    import('./views/accessControl/pushNotifications/pages/AdminPushNotificationsPage'),
);
const OlgaSimulatorPage = React.lazy(
  () => import('./views/tools/olgaSimulator/pages/OlgaSimulatorPage'),
);
const DocumentAISimulatorPage = React.lazy(
  () =>
    import('./views/tools/documentAISimulator/pages/DocumentAISimulatorPage'),
);
const ReactErrorLogsPage = React.lazy(
  () => import('./views/tools/reactErrors/pages/ReactErrorLogsPage'),
);
const EstablishmentCompanies = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentCompanies/pages/EstablishmentCompanyListPage'),
);
const EstablishmentCompanyProfilePage = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentCompanies/pages/EstablishmentCompanyProfilePage'),
);
const EstablishmentCompanyProfessionalProfilePage = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentCompanies/pages/EstablishmentCompanyProfessionalProfilePage'),
);
const EstablishmentCompanyProfessionalsListPage = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentCompanies/pages/EstablishmentCompanyProfessionalsListPage'),
);
const CompanyListPage = React.lazy(
  () => import('./views/accessControl/company/pages/CompanyListPage'),
);
const CompanyFormPage = React.lazy(
  () => import('./views/accessControl/company/pages/CompanyFormPage'),
);

const CompanyProfessional = React.lazy(
  () =>
    import('./views/myCompany/companyProfessional/pages/CompanyProfessionalListPage'),
);

const CompanyProfessionalFormPage = React.lazy(
  () => import('./views/myCompany/companyProfessional/pages/CompanyProfessionalFormPage'),
);

const CompanyProfessionalLinked = React.lazy(
  () =>
    import('./views/myCompany/companyProfessional/pages/CompanyProfessionalLinkedPage'),
);

const CompanyProfessionalProfilePage = React.lazy(
  () =>
    import('./views/myCompany/companyProfessional/pages/CompanyProfessionalProfilePage'),
);

const UsersCompany = React.lazy(
  () => import('./views/myCompany/companyUser/pages/UsersCompanyListPage'),
);

const UsersCompanyRegister = React.lazy(
  () => import('./views/myCompany/companyUser/pages/UsersCompanyFormPage'),
);

const CompanyEstablishments = React.lazy(
  () =>
    import('./views/myCompany/companyEstablishment/pages/CompanyEstablishmentLinkedPage'),
);

const CompanyEstablishmentProfilePage = React.lazy(
  () =>
    import('./views/myCompany/companyEstablishment/pages/CompanyEstablishmentProfilePage'),
);

const ManageCompany = React.lazy(
  () => import('./views/myCompany/manageCompany/pages/ManageCompanyPage'),
);

const ScheduledShiftListPage = React.lazy(
  () =>
    import('./views/scaleManagement/scheduledShift/pages/ScheduledShiftListPage'),
);

const ScheduledShiftFormPage = React.lazy(
  () =>
    import('./views/scaleManagement/scheduledShift/pages/ScheduledShiftFormPage'),
);
const ScheduledShiftPlanPage = React.lazy(
  () =>
    import('./views/scaleManagement/scheduledShiftPlan/pages/ScheduledShiftPlanPage'),
);

const EstablishmentDocumentManagement = React.lazy(
  () =>
    import('./views/myEstablishment/establishmentDocumentManagement/pages/DocumentManagementFormPage'),
);
const CompanyDocumentManagement = React.lazy(
  () =>
    import('./views/myCompany/documentManagement/pages/CompanyDocumentManagementPage'),
);

const CalendarsMainPage = React.lazy(
  () =>
    import('./views/scaleManagement/myCompany/calendars/pages/CalendarsMainPage'),
);
const CompanyCalendarPage = React.lazy(
  () =>
    import('./views/scaleManagement/myCompany/calendars/pages/CompanyCalendarPage'),
);
const CompanySchedulePlanListPage = React.lazy(
  () =>
    import('./views/scaleManagement/myCompany/schedulePlan/pages/CompanySchedulePlanListPage'),
);
const CompanySchedulePlanPage = React.lazy(
  () =>
    import('./views/scaleManagement/myCompany/schedulePlan/pages/CompanySchedulePlanPage'),
);

const OverviewMainPage = React.lazy(
  () =>
    import('./views/scaleManagement/myCompany/overview/pages/OverviewMainPage'),
);
const ReportsLayoutPage = React.lazy(
  () => import('./views/reports/pages/ReportsLayoutPage'),
);
const TransferReportPage = React.lazy(
  () => import('./views/reports/transfer/pages/TransferReportPage'),
);
const AttendanceDashboardPage = React.lazy(
  () => import('./views/dashboard/attendance/pages/AttendanceDashboardPage'),
);
const EngagementDashboardPage = React.lazy(
  () => import('./views/dashboard/engagement/pages/EngagementDashboardPage'),
);
const RQEDocumentsDashboardPage = React.lazy(
  () =>
    import('./views/dashboard/rqeDocuments/pages/RQEDocumentsDashboardPage'),
);
const JobProposalsPage = React.lazy(
  () => import('./views/jobProposals/pages/JobProposalsPage'),
);
const JobProposalAdvancedSettingsPage = React.lazy(
  () => import('./views/jobProposals/pages/JobProposalAdvancedSettingsPage'),
);
const CheckInOutReportPage = React.lazy(
  () => import('./views/reports/checkinCheckout/pages/CheckInOutReportPage'),
);
const AttendanceAdjustmentImportPage = React.lazy(
  () =>
    import('./views/reports/attendanceAdjustmentImport/pages/AttendanceAdjustmentImportPage'),
);
const PastShiftImportPage = React.lazy(
  () => import('./views/tools/pastShiftImport/pages/PastShiftImportPage'),
);
const MissingSpecialtyDocumentReportPage = React.lazy(
  () =>
    import('./views/reports/missingSpecialtyDocument/pages/MissingSpecialtyDocumentReportPage'),
);
const BankDataReportPage = React.lazy(
  () => import('./views/reports/bankData/pages/BankDataReportPage'),
);
const ProposalsManagementReportPage = React.lazy(
  () =>
    import('./views/reports/proposalsManagement/pages/ProposalsManagementReportPage'),
);
const CustomReportsListPage = React.lazy(
  () => import('./views/reports/customReports/pages/CustomReportsListPage'),
);
const CustomReportFormPage = React.lazy(
  () => import('./views/reports/customReports/pages/CustomReportFormPage'),
);
const CustomReportRunPage = React.lazy(
  () => import('./views/reports/customReports/pages/CustomReportRunPage'),
);
const TeleattendanceListPage = React.lazy(
  () => import('./views/teleattendance/pages/TeleattendanceListPage'),
);
const TeleattendanceRoomPage = React.lazy(
  () => import('./views/teleattendance/pages/TeleattendanceRoomPage'),
);
const CnesProfessionalLinkPage = React.lazy(
  () => import('./views/integrations/cnes/pages/CnesProfessionalLinkPage'),
);
const OnboardingSettingsPage = React.lazy(
  () => import('./views/onboardingSettings/pages/OnboardingSettingsPage'),
);
const OnboardingInterviewsPage = React.lazy(
  () => import('./views/onboardingInterviews/pages/OnboardingInterviewsPage'),
);
const CredentialingPage = React.lazy(
  () => import('./views/credentialing/pages/CredentialingPage'),
);

const RecordAuthorizationPage = React.lazy(
  () =>
    import('./views/scaleManagement/recordAuthorization/pages/RecordAuthorizationPage'),
);
const ShiftExchangeValidationPage = React.lazy(
  () =>
    import('./views/scaleManagement/shiftExchanges/pages/ShiftExchangeValidationPage'),
);
const CompanyShiftExchangeValidationPage = React.lazy(() =>
  import('./views/scaleManagement/shiftExchanges/pages/ShiftExchangeValidationPage').then(
    (module) => ({ default: module.CompanyShiftExchangeValidationPage }),
  ),
);

export interface AppRoute {
  key: string;
  path: string;
  element: React.ComponentType;
  children?: AppRoute[];
  hideFromMenu?: boolean;
}

export const getAppRoutes = (
  establishment_config_id: string | null,
  company_config_id: string | null,
  is_config_admin = false,
  is_company_admin = false,
  is_master = false,
): AppRoute[] => {
  const hasCompanyContext = Boolean(company_config_id);
  const routes: AppRoute[] = [
    {
      key: 'home',
      path: '/home',
      element: Home,
    },
    {
      key: 'establishment-home',
      path: '/establishment/home',
      element: EstablishmentHomePage,
    },
    {
      key: 'company-home',
      path: '/company/home',
      element: MedicalCompanyHomePage,
    },
    {
      key: 'profile-settings',
      path: '/profile',
      element: ProfileSettingsPage,
      hideFromMenu: true,
    },
    {
      key: 'teleattendance',
      path: '/teleattendance',
      element: TeleattendanceListPage,
    },
    {
      key: 'teleattendance-room',
      path: '/teleattendance/room/:schedulePlanningProfessionalId',
      element: TeleattendanceRoomPage,
      hideFromMenu: true,
    },
    {
      key: 'access-control',
      path: '/access-control',
      element: Outlet,
      children: [
        {
          key: 'roles',
          path: '/access-control/roles',
          element: RolesListPage,
        },
        {
          key: 'roles_register',
          path: '/access-control/roles/register',
          element: RoleFormPage,
          hideFromMenu: true,
        },
        {
          key: 'roles_edit',
          path: '/access-control/roles/edit/:id',
          element: RoleFormPage,
          hideFromMenu: true,
        },
        {
          key: 'roles_permissions',
          path: '/access-control/roles/:id/permissions',
          element: RolePermissionsPage,
          hideFromMenu: true,
        },
        {
          key: 'manage_users',
          path: '/access-control/manage-users',
          element: ManageUserListPage,
        },
        {
          key: 'manage_users',
          path: '/access-control/manage-users/register',
          element: ManageUserFormPage,
          hideFromMenu: true,
        },
        {
          key: 'manage_users',
          path: '/access-control/manage-users/edit/:id',
          element: ManageUserFormPage,
          hideFromMenu: true,
        },
        {
          key: 'audit_logs',
          path: '/access-control/audit-logs',
          element: AuditLogListPage,
        },
        {
          key: 'invite_codes',
          path: '/access-control/invite-codes',
          element: InviteCodeListPage,
        },
        ...(is_master
          ? [
              {
                key: 'admin_push_notifications',
                path: '/access-control/push-notifications',
                element: AdminPushNotificationsPage,
              },
            ]
          : []),
        {
          key: 'facesign_analysis_desk',
          path: '/access-control/facesign-analysis-desk',
          element: FaceSignAnalysisDeskPage,
        },
        {
          key: 'facesign_events',
          path: '/access-control/facesign-events',
          element: FaceSignEventsPage,
        },
        {
          key: 'establishments',
          path: '/access-control/establishments',
          element: EstablishmentListPage,
        },
        {
          key: 'establishments',
          path: '/access-control/establishments/register',
          element: EstablishmentFormPage,
          hideFromMenu: true,
        },
        {
          key: 'establishments',
          path: '/access-control/establishments/edit/:id',
          element: EstablishmentFormPage,
          hideFromMenu: true,
        },
        {
          key: 'establishmentsLinkProfessional',
          path: '/access-control/establishments/linked-professionals/:id',
          element: EstablishmentLinkProfessionalPage,
          hideFromMenu: true,
        },
        {
          key: 'companies',
          path: '/access-control/companies',
          element: CompanyListPage,
        },
        {
          key: 'companies',
          path: '/access-control/companies/register',
          element: CompanyFormPage,
          hideFromMenu: true,
        },
        {
          key: 'companies',
          path: '/access-control/companies/edit/:id',
          element: CompanyFormPage,
          hideFromMenu: true,
        },
      ],
    },
    ...(is_master
      ? [
          {
            key: 'tools',
            path: '/tools',
            element: Outlet,
            children: [
              {
                key: 'admin_olga_simulator',
                path: '/tools/olga-simulator',
                element: OlgaSimulatorPage,
              },
              {
                key: 'admin_document_ai_simulator',
                path: '/tools/document-ai-simulator',
                element: DocumentAISimulatorPage,
              },
              {
                key: 'admin_react_errors',
                path: '/tools/react-errors',
                element: ReactErrorLogsPage,
              },
            ],
          },
        ]
      : []),
    {
      key: 'technicalStaff',
      path: '/technical-staff',
      element: Outlet,
      children: [
        {
          key: 'professionals',
          path: '/technical-staff/professionals',
          element: ProfessionalListPage,
        },
        {
          key: 'professionalProfile',
          path: '/technical-staff/professionals/profile/:id',
          element: ProfessionalProfilePage,
          hideFromMenu: true,
        },
        {
          key: 'professionalEdit',
          path: '/technical-staff/professionals/edit/:id',
          element: ProfessionalEditPage,
          hideFromMenu: true,
        },
        {
          key: 'categories',
          path: '/technical-staff/categories',
          element: CategoriesListPage,
        },
        {
          key: 'categoriesRegister',
          path: '/technical-staff/categories/register',
          element: CategoriesFormPage,
          hideFromMenu: true,
        },
        {
          key: 'categoriesEdit',
          path: '/technical-staff/categories/edit/:id',
          element: CategoriesFormPage,
          hideFromMenu: true,
        },
        {
          key: 'admin_councils',
          path: '/technical-staff/councils',
          element: CouncilsPage,
        },
        {
          key: 'admin_councils',
          path: '/technical-staff/councils/:id/configuration',
          element: CouncilConfigurationPage,
          hideFromMenu: true,
        },
        {
          key: 'council_test',
          path: '/technical-staff/councils/:id/test',
          element: CouncilTestPage,
          hideFromMenu: true,
        },
        {
          key: 'occupations',
          path: '/technical-staff/occupations',
          element: OccupationListPage,
        },
        {
          key: 'rqe',
          path: '/technical-staff/rqe',
          element: RQEListPage,
        },
      ],
    },
  ];

  routes.push({
    key: 'calendar',
    path: '/scale-management/calendar',
    element: CalendarMainPage,
  });

  if (establishment_config_id) {
    routes.push({
      key: 'establishment-tools',
      path: '/establishment/tools',
      element: Outlet,
      children: [
        {
          key: 'est_past_shift_import',
          path: '/establishment/tools/importar-escalas-passadas',
          element: PastShiftImportPage,
        },
      ],
    });

    routes.push({
      key: 'scaleManagement',
      path: '/scale-management',
      element: Outlet,
      children: [
        // {
        //   key: 'scales',
        //         //   path: '/scale-management/scales',
        //   element: ScaleMain,
        //         // },
        {
          key: 'scheduledShift',
          path: '/scale-management/scheduled-shift',
          element: ScheduledShiftListPage,
        },
        {
          key: 'scheduledShiftRegister',
          path: '/scale-management/scheduled-shift/register',
          element: ScheduledShiftFormPage,
          hideFromMenu: true,
        },
        {
          key: 'scheduledShiftPlan',
          path: '/scale-management/scheduled-shift-plan',
          element: ScheduledShiftPlanPage,
          hideFromMenu: true,
        },
        {
          key: 'records',
          path: '/scale-management/records',
          element: RecordsMainPage,
        },
        {
          key: 'est_scale_facesign_intercurrences',
          path: '/scale-management/facesign-intercurrences',
          element: FaceSignIntercurrencesPage,
        },
        {
          key: 'recordAuthorization',
          path: '/scale-management/record-authorization',
          element: RecordAuthorizationPage,
        },
        {
          key: 'est_scale_shift_exchange_validation',
          path: '/scale-management/shift-exchanges',
          element: ShiftExchangeValidationPage,
        },
      ],
    });
  }

  if (establishment_config_id) {
    routes.push({
      key: 'dashboard',
      path: '/dashboard',
      element: Outlet,
      children: [
        {
          key: 'attendanceDashboard',
          path: '/dashboard/attendance',
          element: AttendanceDashboardPage,
        },
        {
          key: 'engagementDashboard',
          path: '/dashboard/engagement',
          element: EngagementDashboardPage,
        },
        {
          key: 'rqeDocumentsDashboard',
          path: '/dashboard/rqe-documents',
          element: RQEDocumentsDashboardPage,
        },
      ],
    });
  }

  if (establishment_config_id) {
    routes.push({
      key: 'reports',
      path: '/reports',
      element: ReportsLayoutPage,
      children: [
        {
          key: 'customReports',
          path: '/reports/custom',
          element: CustomReportsListPage,
        },
        {
          key: 'customReportRegister',
          path: '/reports/custom/register',
          element: CustomReportFormPage,
          hideFromMenu: true,
        },
        {
          key: 'customReportEdit',
          path: '/reports/custom/edit/:id',
          element: CustomReportFormPage,
          hideFromMenu: true,
        },
        {
          key: 'customReportRun',
          path: '/reports/custom/:id/run',
          element: CustomReportRunPage,
          hideFromMenu: true,
        },
        {
          key: 'transferReport',
          path: '/reports/transfer',
          element: TransferReportPage,
        },
        {
          key: 'checkInOutReport',
          path: '/reports/checkin-checkout',
          element: CheckInOutReportPage,
        },
        {
          key: 'attendanceAdjustmentImport',
          path: '/reports/attendance-adjustment-import',
          element: AttendanceAdjustmentImportPage,
        },
        {
          key: 'missingSpecialtyDocumentReport',
          path: '/reports/missing-specialty-document',
          element: MissingSpecialtyDocumentReportPage,
        },
        {
          key: 'proposalsManagementReport',
          path: '/reports/proposals-management',
          element: ProposalsManagementReportPage,
        },
      ],
    });
  }

  if (establishment_config_id && (is_config_admin || is_master)) {
    routes.push({
      key: 'integrations',
      path: '/integrations',
      element: Outlet,
      children: [
        {
          key: 'cnes-professional-link',
          path: '/integrations/cnes-professional-link',
          element: CnesProfessionalLinkPage,
        },
      ],
    });
  }

  routes.push({
    key: 'myEstablishment',
    path: '/my-establishment',
    element: Outlet,
    hideFromMenu: !establishment_config_id && !is_config_admin,
    children: [
      {
        key: 'manageEstablishment',
        path: '/my-establishment/manage-establishment',
        element: ManageEstablishment,
        hideFromMenu: !establishment_config_id && !is_config_admin,
      },
      {
        key: 'establishmentCategories',
        path: '/my-establishment/professional-categories',
        element: EstablishmentCategoriesPage,
        hideFromMenu: !establishment_config_id && !is_config_admin,
      },
      {
        key: 'establishmentCategoryRegister',
        path: '/my-establishment/professional-categories/register',
        element: EstablishmentCategoryRegisterPage,
        hideFromMenu: true,
      },
      {
        key: 'establishmentCategoryEdit',
        path: '/my-establishment/professional-categories/edit/:id',
        element: EstablishmentCategoryEditPage,
        hideFromMenu: true,
      },
      {
        key: 'onboardingSettings',
        path: '/my-establishment/onboarding-settings',
        element: OnboardingSettingsPage,
        hideFromMenu: !establishment_config_id && !is_config_admin,
      },
      {
        key: 'est_onboarding_interviews_queue',
        path: '/my-establishment/onboarding-interviews',
        element: OnboardingInterviewsPage,
        hideFromMenu: true,
      },
      {
        key: 'est_onboarding_interviews_calendar',
        path: '/my-establishment/onboarding-interviews/calendar',
        element: OnboardingInterviewsPage,
        hideFromMenu: true,
      },
      {
        key: 'est_onboarding_credentialing',
        path: '/my-establishment/onboarding-interviews/credentialing',
        element: CredentialingPage,
        hideFromMenu: true,
      },
      {
        key: 'establishmentProfessionals',
        path: '/my-establishment/establishment-professionals',
        element: EstablishmentProfessional,
        hideFromMenu: !establishment_config_id && !is_config_admin,
      },
      {
        key: 'estDocumentValidation',
        path: '/my-establishment/document-validation',
        element: DocumentValidationPage,
        hideFromMenu: !establishment_config_id && !is_config_admin,
      },
      {
        key: 'jobProposals',
        path: '/my-establishment/job-proposals',
        element: JobProposalsPage,
        hideFromMenu: !establishment_config_id && !is_config_admin,
      },
      {
        key: 'jobProposalAdvancedSettings',
        path: '/my-establishment/job-proposals/:id/advanced-settings',
        element: JobProposalAdvancedSettingsPage,
        hideFromMenu: true,
      },
      {
        key: 'establishmentProfessionalsLinked',
        path: '/my-establishment/establishment-professionals-linked',
        element: EstablishmentProfessionalLinked,
        hideFromMenu: true,
      },
      {
        key: 'establishmentProfessionalProfile',
        path: '/my-establishment/establishment-professional-profile/:id',
        element: EstablishmentProfessionalProfilePage,
        hideFromMenu: true,
      },
      {
        key: 'establishmentStatutoryProfessional',
        path: '/my-establishment/establishment-statutory-professional',
        element: EstablishmentStatutoryProfessionalPage,
        hideFromMenu: true,
      },
      {
        key: 'establishmentSpecialities',
        path: '/my-establishment/establishment-specialities',
        element: EstablishmentSpecialityPage,
        hideFromMenu: !establishment_config_id && !is_config_admin,
      },
      {
        key: 'establishmentSpecialitiesRegister',
        path: '/my-establishment/establishment-specialities/register',
        element: EstablishmentSpecialityFormPage,
        hideFromMenu: true,
      },
      {
        key: 'establishmentSpecialitiesEdit',
        path: '/my-establishment/establishment-specialities/edit/:id',
        element: EstablishmentSpecialityFormPage,
        hideFromMenu: true,
      },
      {
        key: 'manageWorkdayEstablishment',
        path: '/my-establishment/manage-workday-establishment',
        element: WorkDayEstablishment,
        hideFromMenu: !establishment_config_id && !is_config_admin,
      },
      {
        key: 'manageSectorEstablishment',
        path: '/my-establishment/manage-sector-establishment',
        element: SectorEstablishment,
        hideFromMenu: !establishment_config_id && !is_config_admin,
      },
      {
        key: 'manageSectorEstablishmentRegister',
        path: '/my-establishment/manage-sector-establishment/register',
        element: SectorEstablishmentRegister,
        hideFromMenu: true,
      },
      {
        key: 'manageSectorEstablishmentEdit',
        path: '/my-establishment/manage-sector-establishment/edit/:id',
        element: SectorEstablishmentRegister,
        hideFromMenu: true,
      },
      {
        key: 'manageRoomEstablishment',
        path: '/my-establishment/manage-room-establishment',
        element: RoomEstablishment,
        hideFromMenu: !establishment_config_id && !is_config_admin,
      },
      {
        key: 'manageRoomEstablishmentRegister',
        path: '/my-establishment/manage-room-establishment/register',
        element: RoomEstablishmentRegister,
        hideFromMenu: true,
      },
      {
        key: 'manageRoomEstablishmentEdit',
        path: '/my-establishment/manage-room-establishment/edit/:id',
        element: RoomEstablishmentRegister,
        hideFromMenu: true,
      },
      {
        key: 'manageRoomEstablishmentAuthorizedProfessionals',
        path: '/my-establishment/manage-room-establishment/:roomId/authorized-professionals',
        element: RoomAuthorizedProfessionalsPage,
        hideFromMenu: true,
      },
      {
        key: 'establishmentDocumentManagement',
        path: '/my-establishment/establishment-document-management',
        element: EstablishmentDocumentManagement,
        hideFromMenu: !establishment_config_id && !is_config_admin,
      },
      {
        key: 'manageUsersEstablishment',
        path: '/my-establishment/manage-users-establishment',
        element: UsersEstablishment,
        hideFromMenu: !establishment_config_id && !is_config_admin,
      },
      {
        key: 'manageUsersEstablishmentRegister',
        path: '/my-establishment/manage-users-establishment/register',
        element: UsersEstablishmentRegister,
        hideFromMenu: true,
      },
      {
        key: 'manageUsersEstablishmentEdit',
        path: '/my-establishment/manage-users-establishment/edit/:id',
        element: UsersEstablishmentRegister,
        hideFromMenu: true,
      },
      {
        key: 'establishmentCompanies',
        path: '/my-establishment/establishment-companies',
        element: EstablishmentCompanies,
        hideFromMenu: !establishment_config_id && !is_config_admin,
      },
      {
        key: 'establishmentCompanyProfile',
        path: '/my-establishment/establishment-company-profile/:id',
        element: EstablishmentCompanyProfilePage,
        hideFromMenu: true,
      },
      {
        key: 'establishmentCompanyProfessionalProfile',
        path: '/my-establishment/establishment-company-professional-profile/:companyId/:professionalId',
        element: EstablishmentCompanyProfessionalProfilePage,
        hideFromMenu: true,
      },
      {
        key: 'establishmentCompanyProfessionals',
        path: '/my-establishment/establishment-company-professionals/:id',
        element: EstablishmentCompanyProfessionalsListPage,
        hideFromMenu: true,
      },
    ],
  });

  if (company_config_id) {
    routes.push({
      key: 'myCompany',
      path: '/my-company',
      element: Outlet,
      hideFromMenu: !company_config_id && !is_company_admin,
      children: [
        {
          key: 'manageCompany',
          path: '/my-company/manage-company',
          element: ManageCompany,
          hideFromMenu: !company_config_id && !is_company_admin,
        },
        {
          key: 'onboardingSettings',
          path: '/my-company/onboarding-settings',
          element: OnboardingSettingsPage,
          hideFromMenu: !company_config_id && !is_company_admin,
        },
        {
          key: 'company_onboarding_interviews_queue',
          path: '/my-company/onboarding-interviews',
          element: OnboardingInterviewsPage,
          hideFromMenu: true,
        },
        {
          key: 'company_onboarding_interviews_calendar',
          path: '/my-company/onboarding-interviews/calendar',
          element: OnboardingInterviewsPage,
          hideFromMenu: true,
        },
        {
          key: 'company_onboarding_credentialing',
          path: '/my-company/onboarding-interviews/credentialing',
          element: CredentialingPage,
          hideFromMenu: true,
        },
        {
          key: 'companyDocumentManagement',
          path: '/my-company/document-management',
          element: CompanyDocumentManagement,
          hideFromMenu: !company_config_id && !is_company_admin,
        },
        // {
        //   key: 'manageSpecialtiesCompany',
        //         //   path: '/my-company/manage-specialties-company',
        //   element: SpecialtiesCompany,
        //   hideFromMenu: !company_config_id && !is_company_admin,
        //         // },
        // {
        //   key: 'manageSpecialtiesCompanyRegister',
        //         //   path: '/my-company/manage-specialties-company/register',
        //   element: SpecialtiesCompanyRegister,
        //   hideFromMenu: true,
        //         // },
        // {
        //   key: 'manageSpecialtiesCompanyEdit',
        //         //   path: '/my-company/manage-specialties-company/edit/:id',
        //   element: SpecialtiesCompanyRegister,
        //   hideFromMenu: true,
        //         // },
        // {
        //   key: 'manageSpecialtiesCompanyLinked',
        //         //   path: '/my-company/manage-specialties-company-linked',
        //   element: SpecialtiesCompanyLinked,
        //   hideFromMenu: true,
        //         // },
        {
          key: 'companyProfessionals',
          path: '/my-company/company-professionals',
          element: CompanyProfessional,
          hideFromMenu: !company_config_id && !is_company_admin,
        },
        {
          key: 'companyDocumentValidation',
          path: '/my-company/document-validation',
          element: DocumentValidationPage,
          hideFromMenu: !company_config_id && !is_company_admin,
        },
        {
          key: 'jobProposals',
          path: '/my-company/job-proposals',
          element: JobProposalsPage,
          hideFromMenu: !company_config_id && !is_company_admin,
        },
        {
          key: 'jobProposalAdvancedSettings',
          path: '/my-company/job-proposals/:id/advanced-settings',
          element: JobProposalAdvancedSettingsPage,
          hideFromMenu: true,
        },
        {
          key: 'companyProfessionalRegister',
          path: '/my-company/company-professionals/register',
          element: CompanyProfessionalFormPage,
          hideFromMenu: true,
        },
        {
          key: 'companyProfessionalsLinked',
          path: '/my-company/company-professionals-linked',
          element: CompanyProfessionalLinked,
          hideFromMenu: true,
        },
        {
          key: 'companyProfessionalProfile',
          path: '/my-company/company-professional-profile/:id',
          element: CompanyProfessionalProfilePage,
          hideFromMenu: true,
        },
        {
          key: 'manageUsersCompany',
          path: '/my-company/manage-users-company',
          element: UsersCompany,
          hideFromMenu: !company_config_id && !is_company_admin,
        },
        {
          key: 'manageUsersCompanyRegister',
          path: '/my-company/manage-users-company/register',
          element: UsersCompanyRegister,
          hideFromMenu: true,
        },
        {
          key: 'manageUsersCompanyEdit',
          path: '/my-company/manage-users-company/edit/:id',
          element: UsersCompanyRegister,
          hideFromMenu: true,
        },
        {
          key: 'companyEstablishments',
          path: '/my-company/company-establishments',
          element: CompanyEstablishments,
          hideFromMenu: !company_config_id && !is_company_admin,
        },
        {
          key: 'companyEstablishmentProfile',
          path: '/my-company/company-establishment-profile/:id',
          element: CompanyEstablishmentProfilePage,
          hideFromMenu: true,
        },
      ],
    });
  }

  if (hasCompanyContext) {
    routes.push({
      key: 'company-scaleManagement',
      path: '/scale-management',
      element: Outlet,
      children: [
        {
          key: 'company-scheduled-shift',
          path: '/scale-management/company-scheduled-shift',
          element: CompanySchedulePlanListPage,
        },
        {
          key: 'company-scheduled-shift-plan',
          path: '/scale-management/company-scheduled-shift-plan',
          element: CompanySchedulePlanPage,
          hideFromMenu: true,
        },
        {
          key: 'company-calendars',
          path: '/scale-management/company-calendars',
          element: CalendarsMainPage,
        },
        {
          key: 'company-calendar',
          path: '/scale-management/company-calendar',
          element: CompanyCalendarPage,
          hideFromMenu: true,
        },
        {
          key: 'company-overview',
          path: '/scale-management/company-overview',
          element: OverviewMainPage,
        },
        {
          key: 'company_scale_shift_exchange_validation',
          path: '/scale-management/company-shift-exchanges',
          element: CompanyShiftExchangeValidationPage,
        },
      ],
    });

    routes.push({
      key: 'company-reports',
      path: '/company/reports',
      element: ReportsLayoutPage,
      children: [
        {
          key: 'company-transfer-report',
          path: '/company/reports/transfer',
          element: TransferReportPage,
        },
        {
          key: 'company-proposals-management-report',
          path: '/company/reports/proposals-management',
          element: ProposalsManagementReportPage,
        },
        {
          key: 'company-missing-specialty-document-report',
          path: '/company/reports/missing-specialty-document',
          element: MissingSpecialtyDocumentReportPage,
        },
        {
          key: 'company-bank-data-report',
          path: '/company/reports/bank-data',
          element: BankDataReportPage,
        },
      ],
    });
  }

  return routes;
};
